<template>
  <div class="container">
    <QueryFrame
      :add-text="handlePermission('goodsLabelAdd')?'新建标签':''"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @addNew='onAdd' :count="count"
      :current='page'
      :disable-page="disablePage"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>标签名称:</label>
            <lk-input :maxlength='20' class="item" placeholder='请输入标签名称'  clearable v-model='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>标签类别:</label>
            <lk-select  class="item"  clearable v-model='query.categoryId'>
            <!-- <lk-option v-for="(item,index) in labelCategoryList" :value="index+1" :key='index'>{{item}}</lk-option> -->
            <lk-option v-for="(item,index) in labelCategoryList" :value="item.id" :key='index'>{{item.name}}</lk-option>

            </lk-select>
          </div>
          <div class="queryItem">
            <label>门店级别:</label>
            <lk-select clearable class="item" v-model="query.storeLevelId">
              <lk-option :value='1'>一级</lk-option>
              <lk-option :value='2'>二级</lk-option>
              <lk-option :value='3'>三级</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
                       <goodsTypeCascader class="item"  v-model='query.goodsTypeId' ></goodsTypeCascader>
            <!-- <lk-select clearable  class="item" v-model.trim="query.goodsTypeId" placeholder="请选择" >
            <lk-option v-for="(item,index) in goodsTypeList" :value="item.id+''" :key='index'>{{item.name}}</lk-option>
          </lk-select> -->
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal
      v-model.trim='visible'
      title='商品标签'
      :closable="false"
      :mask-closable="false">
      <lk-form
        :model="editForm"
        label-position="right"
        :label-width="100"
        :rules="ruleValidate"
        ref="createForm"
        >
        <lk-form-item label="标签名称" prop="name">
          <lk-input :maxlength='20'   v-model.trim="editForm.name" placeholder="请输入"></lk-input>
        </lk-form-item>
        <lk-form-item label="通用门店级别" prop="storeLevelIds">
          <lk-select  v-model.trim="editForm.storeLevelIds" placeholder="请选择" :multiple="true">
            <lk-option value="1">一级</lk-option>
            <lk-option value="2">二级</lk-option>
            <lk-option value="3">三级</lk-option>
          </lk-select>
        </lk-form-item>
        <lk-form-item label="标签类别" prop="categoryIds">
          <lk-select  v-model.trim="editForm.categoryIds" placeholder="请选择" multiple>
            <lk-option v-for="(item,index) in labelCategoryList" :value="item.id+''" :key='index'>{{item.name}}</lk-option>

          </lk-select>
        </lk-form-item>
        <lk-form-item label="商品类型" prop="goodsTypeIds">
          <lk-select  v-model.trim="editForm.goodsTypeIds" placeholder="请选择" multiple>
            <lk-option v-for="(item,index) in getGoodsTypesFormated" :value="item.value+''" :key='index'>{{item.name}}</lk-option>
          </lk-select>
        </lk-form-item>
        <lk-form-item label="资质要求" prop="quaRequirements" v-if="showQuaRequirements">
          <lk-select  v-model.trim="editForm.quaRequirements" placeholder="请选择" clearable>
            <lk-option v-for="(item,index) in publicParams.quaRequirementsList" :value="item.value" :key='index'>{{item.name}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-form>
       <div slot="footer">
        <lk-button @click="onModalCancel">取消</lk-button>
        <lk-button type='primary' @click="onModalOk">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import goodsLabel from '../../../services/goods';
import utils from '../../../libs/utils';
import QueryFrame from '../../../components/frame/QueryFrame';
import mapState from '../../../mixins/mapState';
import queryMixins from '../../../mixins/queryMixins';
import goodsTypeCascader from '../../../components/goodsTypeCascader.vue';

export default {
  name: 'LabelList',
  mixins: [mapState, queryMixins],
  components: { QueryFrame, goodsTypeCascader },
  computed: {
    ...mapGetters(['getGoodsTypesFormated']),
    showQuaRequirements() {
      return this.editForm.goodsTypeIds && this.editForm.goodsTypeIds.includes('2');
    },
  },
  data() {
    return {
      disablePage: false,
      visible: false,

      loading: true,
      editForm: {
        id: '',
        name: '',
        storeLevelIds: '',
        categoryIds: '',
        goodsLabelStatus: '',
        goodsTypeIds: [],
      },

      ruleValidate: {
        name: [
          { required: true, message: '标签名称不能为空', trigger: 'blur' },
        ],
        storeLevelIds: [
          {
            required: true, type: 'array', message: '通用门店级别不能为空', trigger: 'change',
          },
        ],
        categoryIds: [
          {
            required: true, type: 'array', message: '标签类别不能为空', trigger: 'change',
          },
        ],
        goodsTypeIds: [
          {
            required: true, type: 'array', message: '商品类型不能为空', trigger: 'change',
          },
        ],
        quaRequirements: [
          {
            required: true, message: '资质要求不能为空', trigger: 'change', type: 'number',
          },
        ],
      },
      labelCategoryList: [],
      goodsTypeList: [],
      params: {
        name: '',
        storeLevelId: '',
      },
      query: {
        name: '',
        storeLevelId: '',
        page: 0,
        size: 0,
      },
      columns: [
        { title: 'ID', key: 'id', minWidth: 116 },
        { title: '标签名称', key: 'name', minWidth: 116 },
        { title: '适用门店级别', key: 'storeLevels', minWidth: 116 },
        { title: '标签类别', key: 'categories', minWidth: 116 },
        { title: '商品类别', key: 'goodsType', minWidth: 116 },
        { title: '资质要求', key: 'quaRequirementsStr', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },

        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '状态',
          minWidth: 116,
          key: 'goodsLabelStatus',
          render: (h, params) => (this.handlePermission('goodsLabelEdit') ? h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.status === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (e) => { // 接口有问题后续调
                params.row.loading = true;
                if (e) {
                  goodsLabel.enableGoodsLabel({ id: params.row.id }).then((responseData) => {
                    if (responseData.data.status === 200) {
                      this.$Message.success('标签启用');
                      params.row.loading = false;
                    } else {
                      this.$Message.error(responseData.data.error);
                      this.getData();
                    }
                  }).catch((err) => {
                    utils.handleError(err);
                    this.getData();
                  });
                } else {
                  goodsLabel.disableGoodsLabel({ id: params.row.id }).then((responseData) => {
                    if (responseData.data.status === 200) {
                      this.$Message.success('标签禁用');
                      params.row.loading = false;
                    } else {
                      this.getData();
                      this.$Message.error(responseData.data.error);
                    }
                  }).catch((err) => {
                    this.getData();
                    utils.handleError(err);
                  });
                }
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',

            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',

            }, '禁用'),
          ]) : h('span', params.row.status === 1 ? '启用' : '禁用')),

        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.visible = true;
                  goodsLabel.getGoodsLabelById({ id: params.row.id }).then((responseData) => {
                    if (responseData.data.status === 200) {
                      const item = responseData.data.data;
                      this.editForm.goodsTypeIds = item.goodsTypeIds ? item.goodsTypeIds.split(',') : [];
                      this.editForm.id = item.id;
                      this.editForm.name = item.name;
                      this.editForm.storeLevelIds = item.storeLevelIds.split(',');
                      this.editForm.categoryIds = item.categoryIds.split(',');
                      // this.editForm.goodsIds = item.goodsIds.split(',');
                      this.editForm.goodsLabelStatus = item.goodsLabelStatus;
                      this.editForm.quaRequirements = item.quaRequirements
                        ? item.quaRequirements
                        : '';
                    } else {
                      this.$Message.error(responseData.data.error);
                    }
                  }).catch((err) => {
                    utils.handleError(err);
                  });
                },
              },
            }, '修改'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.handleSearch(true);
  },
  methods: {
    clear() {
      this.query.name = '';
      this.query.storeLevelId = '';
      this.query.categoryId = null;
      this.query.goodsTypeId = null;
    },
    onAdd() {
      this.visible = true;
    },
    onModalOk() {
      const data = utils.deepClone(this.editForm);
      const form = this.$refs.createForm;
      let saveFunc = goodsLabel.createGoodsLabel;
      form.validate((valid) => {
        if (valid) {
          // this.loading = false;
          if (data.storeLevelIds) {
            data.storeLevelIds = data.storeLevelIds.sort().join(',');
          }
          if (data.goodsTypeIds) {
            data.goodsTypeIds = data.goodsTypeIds.join(',');
          }
          if (data.categoryIds) {
            data.categoryIds = data.categoryIds.join(',');
          }
          if (data.id) {
            saveFunc = goodsLabel.updateGoodsLabel;
          }
          // console.log(data);
          saveFunc(data).then((res) => {
            if (res.data.status === 200) {
              this.visible = false;
              // this.queryGoodsLabel();
              this.getData();
              form.resetFields();
              this.resetEditForm();
              this.$Message.success(data.id ? '修改成功' : '新建成功');
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写');

          // this.loading = true;
        }
      });
    },
    resetEditForm() {
      this.editForm = {

        id: '',
        name: '',
        storeLevelIds: '',
        categoryIds: '',
        goodsLabelStatus: '',

      };
    },
    onModalCancel() {
      const form = this.$refs.createForm;
      this.visible = false;


      form.resetFields();
      this.resetEditForm();
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // console.log(this.query, this.params);
      goodsLabel.listGoodsLabels(this.params).then((responseData) => {
        if (responseData.data.status === 200) {
          this.tableData = [];
          this.count = responseData.data.data.count;
          // console.log(responseData.data.data);
          responseData.data.data.list.forEach((item) => {
            const result = utils.deepClone(item);
            result.createTime = utils.exchangeTimeToSecond(result.createTime);
            // result.goodsLabelCategoryName = item.goodsLabelCategoryName;
            // utils.exchangeTable(item, result);
            // result.createTime = utils.exchangeTimeToSecond(result.createTime);
            // const regExp = new RegExp(',', 'g');
            // result.storeLevelId = item.storePharmacyLvName.replace(regExp, '；');
            // result.goodsTypeIdsName = [];
            // console.log(result);

            // this.goodsTypeList.forEach((type) => {
            //   console.log(result.goodsTypeIds.split(','));

            //   result.goodsTypeIds.split(',').includes(`${type.id}`) && result.goodsTypeIdsName.push(type.name);
            // });
            // result.goodsTypeIdsName = result.goodsTypeIdsName.join(',');

            result.loading = false;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(responseData.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    getGoodsLabelDropList() {
      goodsLabel.getGoodsLabelDropList().then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          data.forEach((item) => {
            switch (item.type) {
              case 'label_category':
                this.labelCategoryList = utils.deepClone(item.list);
                break;
              case 'goods_type':
                this.goodsTypeList = utils.deepClone(item.list);
                break;

              default:
                break;
            }
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getGoodsLabelDropList();
    // this.getLabels();

    if (!this.handlePermission('goodsLabelEdit')) {
      this.columns = this.columns.slice(0, this.columns.length - 1);
    }
  },
};
</script>
